import { PageContentContainer } from "@fp/ui/components/base/page-layout/page-layout";
import { AdminLayout } from "@/components/admin-layout";
import { AdminPageHeader } from "@/components/admin-page-header";
import { createFileRoute, useRouter } from "@tanstack/react-router";
import { ChevronRight } from "@untitledui/icons";
import { getGetRolesQueryOptions } from "@fp/admin-api-client/client";
import type { RoleDto } from "@fp/admin-api-client";

export const Route = createFileRoute("/settings/roles/")({
	loader: async ({ context: { queryClient } }) => {
		const roles = await queryClient.fetchQuery(getGetRolesQueryOptions());
		return {
			roles: roles.data || ([] as RoleDto[]),
		};
	},
	component: RouteComponent,
});

function RouteComponent() {
	const router = useRouter();
	const { roles } = Route.useLoaderData();

	return (
		<AdminLayout>
			<AdminPageHeader
				title="Roles"
				parent={{ url: "/settings", label: "Settings" }}
			/>
			<PageContentContainer className="space-y-0 bg-white p-0">
				<div className="divide-y divide-gray-200">
					{roles.map((role) => (
						<button
							key={role.id}
							type="button"
							onClick={() =>
								router.navigate({ to: `/settings/roles/${role.id}` })
							}
							className="w-full flex items-center px-4 py-4 hover:bg-gray-50 transition-colors text-left first:border-t first:border-gray-200 last:border-b last:border-gray-200"
						>
							<ChevronRight className="h-5 w-5 text-gray-400 flex-shrink-0 mr-3" />
							<div className="flex-1">
								<div className="flex items-center space-x-2 mb-1">
									<span className="text-lg font-medium text-gray-900">
										{role.name}
									</span>
									<span className="inline-flex items-center justify-center px-2 py-0.5 text-sm font-medium text-gray-600">
										({role.userCount})
									</span>
								</div>
								<p className="text-sm text-gray-500">
									{role.description || "Role description"}
								</p>
							</div>
						</button>
					))}
				</div>
			</PageContentContainer>
		</AdminLayout>
	);
}
